export default class RenderPlugin {
  render(renderer, scene, camera, target = null, autoClear = false, params = null) {
    if (!renderer) {
      return;
    }
    renderer.render(scene, camera, target, autoClear);
  }
}
